import { render, staticRenderFns } from "./directDistribution.vue?vue&type=template&id=78b3a11e&"
import script from "./directDistribution.vue?vue&type=script&lang=js&"
export * from "./directDistribution.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports